var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ShareNetwork"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.90625 15.5C8.5631 15.5 9.90625 14.1569 9.90625 12.5C9.90625 10.8431 8.5631 9.5 6.90625 9.5C5.2494 9.5 3.90625 10.8431 3.90625 12.5C3.90625 14.1569 5.2494 15.5 6.90625 15.5Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4062 22.25C19.0631 22.25 20.4062 20.9069 20.4062 19.25C20.4062 17.5931 19.0631 16.25 17.4062 16.25C15.7494 16.25 14.4062 17.5931 14.4062 19.25C14.4062 20.9069 15.7494 22.25 17.4062 22.25Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.4062 8.75C19.0631 8.75 20.4062 7.40685 20.4062 5.75C20.4062 4.09315 19.0631 2.75 17.4062 2.75C15.7494 2.75 14.4062 4.09315 14.4062 5.75C14.4062 7.40685 15.7494 8.75 17.4062 8.75Z",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.883 7.37207L9.42944 10.8779",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.42944 14.1221L14.883 17.6279",
    stroke: "#7C7C7C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareNetwork);
export default __webpack_public_path__ + "static/media/share-network.2b70f06d283030bdf919751c86ee1ca6.svg";
export { ForwardRef as ReactComponent };